"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmation_glue_history = void 0;
class confirmation_glue_history {
    static init(viewObject) {
        let $confObjects = $(".confObject.historyObject");
        $confObjects.find(".btn.preview").on("click", function () { viewObject.showPreview($(this).attr("data-id")); });
        $confObjects.find(".btn").on("click", function () {
            let vname = viewObject.viewName;
        });
        $confObjects.find(".confInstance").on("click", function () {
            let vname = viewObject.viewName;
        });
        let toggleCollapse = function (e, $this) {
            let $parentConfObject = $this.closest(".confObject.historyObject");
            let btn = $parentConfObject.find(".btn-attachments");
            let attachmentList = $parentConfObject.find(".attachments.history");
            if (btn.hasClass("collapsed")) {
                btn.removeClass("collapsed");
                attachmentList.removeClass("collapse");
            }
            else {
                btn.addClass("collapsed");
                attachmentList.addClass("collapse");
            }
            e.stopPropagation();
        };
        // initalize attachment expand/collapse button
        $confObjects.find(".btn-attachments")
            .off("click")
            .on("click", function (e) { toggleCollapse(e, $(this).closest(".confObject.historyObject")); });
    }
}
exports.confirmation_glue_history = confirmation_glue_history;
